<template>
  <left-side-bar-layout></left-side-bar-layout>
</template>

<script>
import LeftSideBarLayout from '@/components/layout/LeftSideBarLayout'
export default {
    name:"LeftSideBarContainer",
    components: {LeftSideBarLayout}
}
</script>

<style>

</style>